module.exports = __webpack_public_path__ + "assets/primi.23b6a84b.svg";